import { DateTime } from 'luxon';

/**
 * Returns a string in a format like 'Oct 13, 1994 1:30PM'
 * @param {string} isoDateTime ISO 8601 string.
 */
export default function (isoDateTime, timeZone = null) {
  return `${DateTime.fromISO(isoDateTime, { zone: timeZone }).toFormat('DD, t')}`;
}
